// Static, always-visible headline (colored per line). No animation = no risk of
// a line getting stuck hidden. Word spans keep Bengali grapheme clusters intact.
export function SplitHeadline({ lines = [], className = "", lineClassName = "" }) {
  return (
    <h1 className={className} data-testid="hero-headline">
      {lines.map((line, li) => (
        <span key={li} className={`block ${lineClassName}`} style={{ color: line.color }}>
          {line.text}
        </span>
      ))}
    </h1>
  );
}
